var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3560_31558",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3560_31558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0652 14.359C10.2355 14.359 10.3805 14.2989 10.5002 14.1786C10.6198 14.0584 10.6796 13.9131 10.6796 13.7427C10.6796 13.5724 10.6195 13.4274 10.4993 13.3077C10.379 13.1881 10.2337 13.1282 10.0634 13.1282C9.89302 13.1282 9.74802 13.1884 9.62837 13.3086C9.5087 13.4289 9.44887 13.5742 9.44887 13.7445C9.44887 13.9149 9.509 14.0599 9.62927 14.1795C9.74953 14.2992 9.89483 14.359 10.0652 14.359ZM9.63477 11.6202H10.4184C10.4398 11.2025 10.501 10.9047 10.6019 10.7268C10.7029 10.5489 10.8629 10.3467 11.0819 10.1202C11.5787 9.63733 11.9075 9.24523 12.0683 8.94396C12.2291 8.64267 12.3095 8.32628 12.3095 7.99481C12.3095 7.35192 12.103 6.80425 11.6901 6.35179C11.2772 5.89933 10.7416 5.6731 10.0835 5.6731C9.56747 5.6731 9.08643 5.8152 8.64039 6.09939C8.19434 6.38359 7.86714 6.765 7.65881 7.24362L8.40402 7.58177C8.59311 7.13946 8.82575 6.84005 9.10193 6.68354C9.3781 6.52701 9.68072 6.44875 10.0098 6.44875C10.4948 6.44875 10.8757 6.58658 11.1524 6.86223C11.4291 7.13787 11.5675 7.48829 11.5675 7.9135C11.5675 8.24362 11.4652 8.52567 11.2606 8.75964C11.056 8.99363 10.8217 9.23936 10.5579 9.49683C10.1999 9.84512 9.95663 10.1777 9.82789 10.4944C9.69914 10.8112 9.63477 11.1865 9.63477 11.6202ZM10.003 17.1667C9.02139 17.1667 8.09493 16.9803 7.22358 16.6076C6.35223 16.2348 5.58928 15.7214 4.93473 15.0675C4.28018 14.4136 3.76634 13.6514 3.3932 12.7809C3.02007 11.9104 2.8335 10.9844 2.8335 10.0028C2.8335 9.00737 3.01988 8.07744 3.39264 7.21304C3.76542 6.34864 4.27877 5.58916 4.93268 4.9346C5.5866 4.28006 6.3488 3.76622 7.21929 3.39308C8.08979 3.01994 9.01582 2.83337 9.99737 2.83337C10.9928 2.83337 11.9228 3.01976 12.7872 3.39252C13.6516 3.7653 14.411 4.27864 15.0656 4.93256C15.7201 5.58648 16.234 6.34521 16.6071 7.20875C16.9803 8.0723 17.1668 9.0018 17.1668 9.99725C17.1668 10.9788 16.9804 11.9053 16.6077 12.7766C16.2349 13.648 15.7216 14.4109 15.0676 15.0655C14.4137 15.72 13.655 16.2339 12.7915 16.607C11.9279 16.9801 10.9984 17.1667 10.003 17.1667Z",
    fill: "#F59E0B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.14214099cd0724477a83c079357b5956.svg";
export { ForwardRef as ReactComponent };